<template>
  <div class="calendar-wrapper">
    <div class="calendar-header">
      <div class="calendar-header-date">{{currentMonth.format("YYYY年MM月")}}</div>
      <div class="calendar-header-btns">
        <button @click="getPrevMonth()">
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
        </button>
        <button @click="getNextMonth()">
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
        <button @click="getCurMonth()" title="回到当月">
          <i class="fa fa-repeat" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="calendar-body">
      <div class="calendar-body-header">
        <div class="calendar-body-header-item" v-for="(w,index) in weekNames" :key="index">{{w}}</div>
      </div>
      <div class="calendar-body-days" v-for="(line,index) in currentMonthData" :key="index">
        <div class="calendar-body-days-item" v-for="(d,idx) in line.weekDays" :key="idx" v-on:mouseenter="showBtn(d)" v-on:mouseleave="hideBtn(d)"
          :class="{'calendar-body-days-item-disabled':!d.isCurMonth}">
          <div class="calendar-body-days-h" v-show="d.isCurMonth">
            <div class="calendar-body-days-h-icons">
              <!-- <i v-show="d.showBtn" @click="addEvent(d)" class="fa fa-plus-circle" aria-hidden="true"></i> -->
            </div>
            <div class="calendar-body-days-h-date">{{d.day}}日</div>
          </div>
          <div class="calendar-body-days-e" v-for="(e,indx) in d.events" :key="indx" :class="e.cssClass" @click="handleClickEvent(e)">
            {{e.title}}
          </div>
        </div>
      </div>
    </div>
    <div class="calendar-footer"></div>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    name: "fullCalendar",
    props: ["calEvents"],
    mounted() {
      this.getCalendar();
      this.setEvents();
    },
    data() {
      return {
        weekNames: ["日", "一", "二", "三", "四", "五", "六"],
        currentMonth: moment(),
        currentMonthData: []
      };
    },
    computed: {},
    methods: {
      getCalendar() {
        var date = this.currentMonth;
        var days = [];
        var currentWeekday = moment(date)
          .date(1)
          .weekday(); // 获取当月1日为星期几
        var calFirstDay = moment(date)
          .date(1)
          .subtract(currentWeekday, "day"); //计算日历第一天

        for (var i = 0; i < 5; i += 1) {
          var line = { weekDays: [] };
          for (var j = 0; j < 7; j += 1) {
            line.weekDays.push({
              day: calFirstDay.date(),
              date: calFirstDay.format("YYYY-MM-DD"),
              isCurMonth: calFirstDay.isSame(moment(date), "month"),
              showBtn: false,
              events: []
            });

            calFirstDay.add(1, "day");
          }
          days.push(line);

          //如果最后一行没有把当月日期输出完，就再加一行
          if (i === 4) {
            var currentMonthStr = moment(date).format("YYYY-MM-01");
            var nextMonthFirst = moment(currentMonthStr).add(1, "month");
            var isBetweenNextMonth = calFirstDay.isBefore(nextMonthFirst);
            if (isBetweenNextMonth) i--;
          }
        }
        this.currentMonthData = days;
      },
      setEvents() {
        for (var i in this.currentMonthData) {
          var weekDays = this.currentMonthData[i].weekDays;
          for (var j in weekDays) {
            var dayData = weekDays[j];
            var es = this.querycalEvents(dayData.date);
            dayData.events = [];
            for (var e in es) dayData.events.push(es[e]);
          }
        }
      },
      querycalEvents(date) {
        var es = [];
        for (var i in this.calEvents) {
          if (date === this.calEvents[i].date) es.push(this.calEvents[i]);
        }
        return es;
      },
      getPrevMonth() {
        this.currentMonth.add(-1, "month");
        this.getCalendar();

        this.$emit("getPrevMonthData", this.currentMonth);
      },
      getNextMonth() {
        this.currentMonth.add(1, "month");
        this.getCalendar();

        this.$emit("getNextMonthData", this.currentMonth);
      },
      getCurMonth() {
        this.currentMonth = moment();
        this.getCalendar();

        this.$emit("getCurMonthData", this.currentMonth);

      },
      showBtn(d) {
        d.showBtn = true;
      },
      hideBtn(d) {
        d.showBtn = false;
      },
      addEvent(dayData) {
        this.$emit("addEvent", dayData);
      },
      handleClickEvent(ev) {
        this.$emit("handleClickEvent", ev);
      }
    },
    watch: {
      calEvents: function () {
        this.setEvents();
      }
    }
  };
</script>

<style scoped>
  .calendar-wrapper {
    margin: 15px;
    color: rgb(102, 102, 102);
  }

  .calendar-header-date {
    font-weight: bold;
    font-size: 18px;
    display: inline-block;
  }

  .calendar-header-btns {
    display: inline-block;
    float: right;
  }

  .calendar-header-btns button {
    padding: 2px 8px;
    cursor: pointer;
    background: #fff;
    border: 1px solid rgba(102, 102, 102, 0.3);
    color: rgba(0, 0, 0, .5);
  }

  .calendar-header {
    height: 40px;
    background-color: hsla(0, 0%, 92%, .3);
    border: 1px solid hsla(0, 0%, 40%, .3);
    border-bottom: none;
    line-height: 40px;
    padding: 0 10px;
  }

  .calendar-body-header {
    display: table;
    width: 100%;
    height: 40px;
    line-height: 40px;
    table-layout: fixed;
  }

  .calendar-body {
    border-left: 1px solid rgba(102, 102, 102, 0.3);
    border-top: 1px solid rgba(102, 102, 102, 0.3);
  }

  .calendar-body-header-item {
    display: table-cell;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
    border-right: 1px solid rgba(102, 102, 102, 0.3);
    border-bottom: 1px solid rgba(102, 102, 102, 0.3);
    width: 14.2%;
  }

  .calendar-body-days {
    display: table;
    width: 100%;
    height: 120px;
    table-layout: fixed;
  }

  .calendar-body-days-item {
    display: table-cell;
    padding: 5px;
    width: 14.2%;
    border-right: 1px solid rgba(102, 102, 102, 0.3);
    border-bottom: 1px solid rgba(102, 102, 102, 0.3);
  }

  .calendar-body-days-item-disabled {
    background-color: rgba(200, 200, 200, 0.2);
    color: rgba(102, 102, 102, 0.3);
  }

  .calendar-body-days-h {
    text-align: right;
    font-size: 13px;
  }

  .calendar-body-days-h-icons {
    display: inline-block;
    float: left;
    cursor: pointer;
  }

  .calendar-body-days-h-date {
    display: inline-block;
  }

  .calendar-body-days-e {
    font-size: 12px;
    cursor: pointer;
    margin-top: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .event-red {
    color: red;
  }

  .event-blue {
    color: blue;
  }

  .event-gray {
    color: gray;
  }

  .event-green {
    color: green;
  }
</style>


// WEBPACK FOOTER //
// src/components/customComponents/fullCalendar/fullCalendar.vue